import { z } from "zod";

/**
 * Carousel template group with size variants
 */
export const CarouselTemplateGroupSchema = z.object({
  baseName: z.string(),
  availableTemplates: z.array(
    z.object({
      language: z.string(),
      carouselSize: z.number(),
      templateId: z.string()
    })
  ),
  defaultLanguage: z.string().optional(),
  minCarouselSize: z.number().optional(),
  maxCarouselSize: z.number().optional()
});

export type CarouselTemplateGroup = z.infer<typeof CarouselTemplateGroupSchema>;
